export default class MainVisual {
    constructor() {
        this.init();
    }

    init() {
        this.MVslide();
    }

    MVslide() {
        //PC版でも背後で動かしておく
        let index = 0;
        const duration = 6000;
        const slideitem = [...document.querySelectorAll(".js-mainvisual_slide .ph")];

        const slide = () => {
            slideitem.forEach((el, _index) => {
                el.classList.remove("-out");

                if (el.classList.contains("-active")) {
                    el.classList.remove("-active");
                    el.classList.add("-out");
                }

                if (index === _index) {
                    el.classList.remove("-out");
                    el.classList.add("-active");
                }
            });

            index++;

            if (index > slideitem.length - 1) {
                index = 0;
            }

            setTimeout(slide, duration);
        };

        slide();
    }
}
